import {useMemo,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {getYouTubeId} from '../lib/youtubeUtils';

const {FiArrowUpRight,FiPlay}=FiIcons;

function videoIdFor(release) {
  return release.video_id || getYouTubeId(release.url);
}

export default function YouTubeReleaseGrid({releases}) {
  const playable=useMemo(
    ()=> releases.filter((release)=> videoIdFor(release)),
    [releases]
  );
  const [selectedId,setSelectedId]=useState(
    ()=> videoIdFor(playable[0] || {})
  );
  const selected=playable.find(
    (release)=> videoIdFor(release)===selectedId
  ) || playable[0];

  if (!selected) return null;

  const activeId=videoIdFor(selected);

  return (
    <section className="space-y-3" aria-label="Latest YouTube music releases">
      <div className="overflow-hidden rounded-[18px] border border-white/10 bg-[#171b24] shadow-2xl">
        <div className="aspect-video bg-black">
          <iframe
            key={activeId}
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${activeId}?rel=0`}
            title={selected.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <div className="flex items-center gap-3 p-4">
          <div className="min-w-0 flex-1">
            <p className="text-[9px] font-semibold uppercase tracking-[0.16em] text-[#64e8ce]">
              Now playing
            </p>
            <h2 className="mt-1 truncate text-base font-bold text-white">
              {selected.title}
            </h2>
          </div>
          <a
            href={selected.url}
            target="_blank"
            rel="noreferrer"
            className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-white/10 text-slate-300 transition hover:border-cyan-300/40 hover:text-cyan-200"
            aria-label={`Open ${selected.title} on YouTube`}
          >
            <SafeIcon icon={FiArrowUpRight} className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        {playable.map((release)=> {
          const videoId=videoIdFor(release);
          const active=videoId===activeId;

          return (
            <button
              type="button"
              key={videoId}
              onClick={()=> setSelectedId(videoId)}
              className={`group overflow-hidden rounded-2xl border text-left transition ${
                active
                  ? 'border-cyan-300/50 bg-cyan-300/10'
                  : 'border-white/10 bg-white/[0.04] hover:border-white/20'
              }`}
              aria-pressed={active}
            >
              <span className="relative block aspect-video overflow-hidden bg-black">
                <img
                  src={release.image_url}
                  alt=""
                  loading="lazy"
                  className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                />
                <span className="absolute inset-0 grid place-items-center bg-black/20">
                  <span className="grid h-9 w-9 place-items-center rounded-full bg-black/70 text-white backdrop-blur">
                    <SafeIcon icon={FiPlay} className="h-4 w-4 translate-x-px" />
                  </span>
                </span>
              </span>
              <span className="block p-3">
                <strong className="line-clamp-2 text-xs leading-5 text-white">
                  {release.title}
                </strong>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}